var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:['checkpoint-inspection-badge', `checkpoint-inspection-badge--${_setup.displayState}`]},[_vm._v(" "+_vm._s(_setup.displayText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }